import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import u1 from "../media3/categories/p8.png";
import u2 from "../media3/categories/c1.png";
import u3 from "../media3/categories/k1.png";
import u4 from "../media3/categories/r1.png";
import u5 from "../media3/categories/m1.png";
import u6 from "../media3/categories/g1.png";
import u7 from "../media3/categories/s1.png";
import u8 from "../media3/categories/a1.png";

const upcomingSkins = [
  { title: "Explore Pistols", img: u1, path: "/categories/pistols", price: "$160" },
  { title: "Explore Cases", img: u2, path: "/categories/cases", price: "$61.00" },
  { title: "Explore Knives", img: u3, path: "/categories/knives", price: "$110.96" },
  { title: "Explore Rifles", img: u4, path: "/categories/rifle", price: "$145.97" },
  { title: "Explore Mid-Tier", img: u5, path: "/categories/mid-tier", price: "$68.76" },
  { title: "Explore Gloves", img: u6, path: "/categories/gloves", price: "$92.30" },
  { title: "Explore Stickers", img: u7, path: "/categories/stickers", price: "$115.99" },
  { title: "Explore Agents", img: u8, path: "/categories/agents", price: "$99.45" },
];

const UpcomingSkins = () => {
  const carouselRef = useRef(null);
  const [activeDot, setActiveDot] = useState(0);
  const navigate = useNavigate();

  const scroll = (direction) => {
    const container = carouselRef.current;
    const scrollAmount = container.offsetWidth; 
    if (direction === "next") {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setActiveDot((prev) => Math.min(prev + 1, upcomingSkins.length - 4));
    } else {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setActiveDot((prev) => Math.max(prev - 1, 0));
    }
  };

  const handleCardClick = (path) => {
    setTimeout(() => {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);
    }, 150);
  };

  return (
    <div className="upcoming-skins-section" id="upcoming-skins">
 
    
            <span className="section-decorative-bar">
                 Best Upcoming Skins For You
             </span>
                 <div className="upcoming-title">
             <h1>Explore skins that define your game </h1>
             <p>From rare knives to iconic weapon skins, SkinForge brings you a curated
                 collection of must-have items ready for you to buy and add to your
                 inventory.</p>
            </div>
             <div className="upcoming-skins-header">
           <div>
            <h2>Explore Exclusive Skins</h2>  
           </div>
        <div className="header-actions">
          <div className="carousel-controls">
              <a href="/categories" className="view-all">
            View All →
          </a>
            <button onClick={() => scroll("prev")}>{`<`}</button>
            <button onClick={() => scroll("next")}>{`>`}</button>
          </div>
        </div>
       </div>

        <div className="skins-carousel" ref={carouselRef}>
        {upcomingSkins.map((skin, index) => (
          <div 
            className="upcoming-skin-card" 
            key={index}
            onClick={() => handleCardClick(skin.path)}
          >
            <div className="card-image-container">
              <img src={skin.img} alt={skin.title} />
            </div>
            <div className="skin-info">
              <h3>{skin.title}</h3>
              <div className="skin-price">{skin.price}</div>
            </div>
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default UpcomingSkins;